import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/Login'
import Dashboard from '@/components/Dashboard'
import Filetree from '@/components/Filetree'
import Main from '@/components/Main'
import Directory from '@/components/Directory'
import Folder from '@/components/Folder'
import Document from '@/components/Document'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Login',
      component: Login
    },
    {
      path: '/dashboard',
      name: 'Dashboard',
      component: Dashboard
    },
    {
      path: '/file-tree',
      name: 'Filetree',
      component: Filetree
    },
    {
      path: '/main',
      name: 'Main',
      component: Main
    },
    {
      path: '/directory/:slug',
      name: 'Directory',
      component: Directory
    },
    {
      path: '/folder/:slug',
      name: 'Folder',
      component: Folder
    },
    {
      path: '/document/:id/:slug',
      name: 'Document',
      component: Document
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js